import React from 'react';
import { Download } from 'lucide-react';
import SearchBox from '../searchbox/SearchBox';

const UserToolbar = ({
  searchTerm,
  onSearchChange,
  onDownloadClick,
  canDownload,
  loading
}) => {
  return (
    <div className="search-filters-container">
      <SearchBox 
        placeholder="Search users by name or email..." 
        value={searchTerm} 
        onChange={onSearchChange} 
      />
      <button 
        className="btn btn-filters" 
        style={{ boxShadow: 'none' }} 
        onClick={onDownloadClick}
        disabled={!canDownload || loading}
        title={!canDownload ? 'You do not have permission to download users' : 'Download users as CSV'}
      >
        <Download size={16} marginRight={0} />
      </button>
    </div>
  );
};

export default UserToolbar;

